// components/ProtectedRoute.js
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";

const ProtectedRoute = ({ children }) => {

    const { id } = useParams();

    const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

    return isAuthenticated ? children : <Navigate to={"/"+id} />;
};

export default ProtectedRoute;
